module.exports = __webpack_public_path__ + "static/media/home_banner_call_for_registration.87ec0be3.svg";